<div class="student-detail-page">

    @if (isLoading) {
  
      <div class="detail-loading">
        Cargando expediente del estudiante...
      </div>
  
    } @else {
  
      @if (student) {
  
        <a
          class="back-link"
          routerLink="/student"
        >
          ← Volver a estudiantes
        </a>
  
  
        <!-- =========================================
             HERO
        ========================================== -->
        <section class="student-hero">
          <div class="hero-top-row">
            <div class="hero-main">
              <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 6px; flex-wrap: wrap;">
                <span class="eyebrow" style="margin-bottom: 0;">
                  EXPEDIENTE DEL ESTUDIANTE
                </span>
                <span class="hero-type-pill">
                  SERVICIO SOCIAL
                </span>

                @if (student.accountStatus === 'pending') {
                  <span class="status-pill pill-pending">⏳ Pendiente de Aceptación</span>
                } @else if (student.accountStatus === 'rejected') {
                  <span class="status-pill pill-rejected">✕ Rechazado</span>
                }
              </div>

              <div style="display: flex; align-items: center; gap: 14px; flex-wrap: wrap; margin-bottom: 4px;">
                <h1 style="margin: 0;">
                  {{ student.fullName || 'Estudiante' }}
                </h1>
                @if (student.folio) {
                  <button
                    type="button"
                    class="hero-folio-btn"
                    [class.is-copied]="isFolioCopied"
                    (click)="copyFolioToClipboard($event)"
                    [attr.aria-label]="isFolioCopied ? 'Folio copiado al portapapeles' : 'Copiar folio al portapapeles'"
                    [title]="isFolioCopied ? '¡Copiado!' : 'Clic para copiar folio al portapapeles'"
                  >
                    @if (isFolioCopied) {
                      <span class="folio-copied-content">
                        <span class="material-symbols-outlined folio-check-icon">check_circle</span>
                        <span class="folio-copied-text">¡Folio copiado!</span>
                      </span>
                    } @else {
                      <span class="folio-default-content">
                        <span class="folio-label">FOLIO:</span>
                        <span class="folio-code">{{ student.folio }}</span>
                        <span class="material-symbols-outlined folio-copy-icon">content_copy</span>
                      </span>
                    }
                  </button>
                }
              </div>

              <p>
                {{ student.schoolMail || student.mail }}
                @if (student.career || student.school) {
                  <span class="hero-meta-dot">•</span>
                  <span>{{ student.career || 'Sin carrera' }} — {{ student.school || 'Sin escuela registrada' }}</span>
                }
              </p>
            </div>

            @if (student.accountStatus === 'active') {
              <div class="hero-actions">
                <button
                  type="button"
                  class="btn-inactivate-hero"
                  (click)="openInactivateModal()"
                  title="Inactivar cuenta por decisión administrativa"
                >
                  <span class="material-symbols-outlined">person_off</span>
                  <span>Inactivar Cuenta</span>
                </button>
              </div>
            }
          </div>

          <!-- FILA DE STATS / INFORMACIÓN Y MÉTRICAS DEL EXPEDIENTE INTEGRADA EN EL GRADIENTE -->
          <div class="hero-stats-row">
            <div class="hero-stat-card">
              <span class="hero-stat-label">ESTATUS</span>
              <div class="hero-stat-value">
                @if (student.accountStatus === 'pending') {
                  <strong class="status-pending" style="color: #fde047;">⏳ Pendiente</strong>
                } @else if (student.accountStatus === 'rejected') {
                  <strong class="status-rejected" style="color: #fca5a5;">✕ Rechazado</strong>
                } @else {
                  <strong class="status-active" style="color: #86efac;">● Activo</strong>
                }
              </div>
              <small class="hero-stat-sub">Estado actual de acceso</small>
            </div>

            <div class="hero-stat-card hero-stat-card-combined">
              <div class="combined-stat-col">
                <span class="hero-stat-label">EMISIÓN DE EXPEDIENTE</span>
                <strong class="hero-stat-value">
                  {{ (student.fechaEmisionExpediente || student.created) ? ((student.fechaEmisionExpediente || student.created) | date:'dd/MM/yyyy HH:mm') : 'N/A' }}
                </strong>
                <small class="hero-stat-sub">Finalización de formulario</small>
              </div>

              <div class="combined-stat-divider"></div>

              <div class="combined-stat-col">
                <span class="hero-stat-label">ACEPTACIÓN / EXPEDICIÓN</span>
                <strong class="hero-stat-value" [style.color]="student.accountStatus === 'active' ? '#86efac' : 'rgba(255, 255, 255, 0.9)'">
                  {{ (student.fechaAceptacionExpediente || student.fechaExpedicionExpediente) ? ((student.fechaAceptacionExpediente || student.fechaExpedicionExpediente) | date:'dd/MM/yyyy HH:mm') : (student.accountStatus === 'pending' ? 'Pendiente' : 'N/A') }}
                </strong>
                <small class="hero-stat-sub">Validación de ABAQ</small>
              </div>
            </div>

            <div class="hero-stat-card">
              <span class="hero-stat-label">OPORTUNIDADES GENERADAS</span>
              <strong class="hero-stat-value">
                {{ opportunitiesCount }}
                <span style="font-size: 0.85rem; font-weight: 600; opacity: 0.85; margin-left: 2px;">
                  {{ opportunitiesCount === 1 ? 'oportunidad' : 'oportunidades' }}
                </span>
              </strong>
              <small class="hero-stat-sub">Vinculaciones registradas</small>
            </div>

            <div class="hero-stat-card">
              <span class="hero-stat-label">ACTIVIDADES</span>
              <strong class="hero-stat-value">
                {{ activitiesCount }}
                <span style="font-size: 0.85rem; font-weight: 600; opacity: 0.85; margin-left: 2px;">
                  {{ activitiesCount === 1 ? 'actividad' : 'actividades' }}
                </span>
              </strong>
              <small class="hero-stat-sub">Participación en programas</small>
            </div>

            <div class="hero-stat-card hero-stat-card-total">
              <span class="hero-stat-label">SUMA TOTAL</span>
              <strong class="hero-stat-value">
                {{ totalStatsCount }}
                <span style="font-size: 0.85rem; font-weight: 600; opacity: 0.85; margin-left: 2px;">
                  {{ totalStatsCount === 1 ? 'registro' : 'registros' }}
                </span>
              </strong>
              <small class="hero-stat-sub">Oportunidades + actividades</small>
            </div>
          </div>
        </section>

        @if (statusFeedback) {
          <div
            class="status-feedback-alert"
            [ngClass]="statusFeedback.startsWith('Error') ? 'alert-danger' : 'alert-success'"
          >
            {{ statusFeedback }}
          </div>
        }

        <!-- BANNER DE APROBACIÓN DE NUEVO EXPEDIENTE -->
        @if (student.accountStatus === 'pending') {
          <div class="pending-approval-banner">
            <div class="banner-content">
              <div class="banner-icon-box">
                <span class="material-symbols-outlined">how_to_reg</span>
              </div>
              <div class="banner-texts">
                <div class="banner-kicker">SOLICITUD DE INGRESO · SERVICIO SOCIAL</div>
                <h3>Nuevo estudiante pendiente de aceptación</h3>
                <p>
                  {{ student.fullName }} completó su proceso de onboarding y registro y su expediente está esperando validación de la Coordinación de ABAQ. Al aceptarlo, se activará su cuenta, se emitirá su <strong>Carta de Aceptación oficial con folio institucional</strong> y se enviará por correo.
                </p>
              </div>
            </div>

            <div class="banner-action-buttons">
              <button
                type="button"
                class="btn-accept-student"
                (click)="acceptStudent(student.id)"
                [disabled]="isAccepting"
                title="Aceptar e ingresar estudiante"
              >
                <span class="material-symbols-outlined">check</span>
                @if (isAccepting) {
                  Aceptando estudiante...
                } @else {
                  Aceptar Estudiante y Emitir Carta
                }
              </button>

              <button
                type="button"
                class="btn-reject-student"
                (click)="rejectStudent(student.id)"
                [disabled]="isRejecting || isAccepting"
                title="Rechazar solicitud de ingreso"
              >
                <span class="material-symbols-outlined">close</span>
                @if (isRejecting) {
                  Rechazando...
                } @else {
                  Rechazar
                }
              </button>
            </div>
          </div>
        }
  
  
        <!-- =========================================
             BITÁCORA DE ESTATUS / BAJA (Fase C4.1)
        ========================================== -->
        @if (student.accountStatus === 'inactive') {
          <div class="inactive-reason-banner">
            <span class="material-symbols-outlined">block</span>
            <div>
              <span class="inactive-banner-title">Cuenta dada de baja (inactiva)</span>
              <span class="inactive-banner-reason">
                Causal: {{ getFriendlyReason(lastStatusChange?.reason) }}
              </span>
              @if (lastStatusChange?.comments) {
                <p class="inactive-banner-comments">
                  {{ lastStatusChange.comments }}
                </p>
              }
              @if (lastStatusChange?.date) {
                <span class="status-history-date">
                  {{ lastStatusChange.date | date:'dd/MM/yyyy HH:mm' }}
                </span>
              }
            </div>
          </div>
        } @else if (lastStatusChange) {
          <div class="status-history-note">
            <span class="status-history-title">Última transición de estatus</span>
            <span class="status-history-reason">
              {{ getFriendlyReason(lastStatusChange.reason) }}
            </span>
            @if (lastStatusChange.comments) {
              <p class="status-history-comments">
                {{ lastStatusChange.comments }}
              </p>
            }
            @if (lastStatusChange.date) {
              <span class="status-history-date">
                {{ lastStatusChange.date | date:'dd/MM/yyyy HH:mm' }}
              </span>
            }
          </div>
        }

        <!-- =========================================
             RESUMEN DE SERVICIO SOCIAL
        ========================================== -->
        <div class="section-header">
          <div>
            <span class="section-kicker">SERVICIO SOCIAL</span>
            <h2>Resumen y control de horas</h2>
            <p style="margin: 4px 0 0; color: #64748b; font-size: 13.5px;">Seguimiento institucional de horas reglamentarias y acreditaciones.</p>
          </div>
        
          <button
            type="button"
            class="new-accreditation-button"
            (click)="openAccreditationModal()"
          >
            + Nueva acreditación
          </button>
        </div>
  
        <section class="summary-grid">
  
          <article class="summary-card">
  
            <span>
              Horas requeridas
            </span>
  
            <strong>
              {{ student.horasCubrir }}
            </strong>
  
            <small>
              Total del periodo actual
            </small>
  
          </article>
  
  
          <article class="summary-card">
  
            <span>
              Horas acreditadas
            </span>
  
            <strong>
              {{ student.horasAcreditadas }}
            </strong>
  
            <small>
              Progreso validado
            </small>
  
          </article>
  
  
          <article class="summary-card">
  
            <span>
              Horas pendientes
            </span>
  
            <strong>
              {{ student.horasPendientes }}
            </strong>
  
            <small>
              Restantes por acreditar
            </small>
  
          </article>
  
  
          <article class="summary-card">
  
            <span>
              Actividades
            </span>
  
            <strong>
              {{ student.assignedActivities.length }}
            </strong>
  
            <small>
              Registros totales
            </small>
  
          </article>
  
        </section>
  
  
       <!-- =========================================
     INFORMACIÓN PERSONAL
========================================== -->

<section class="detail-card">

    <div class="section-title">
  
      <div>
  
        <span class="section-kicker">
          Perfil
        </span>
  
        <h2>
          Información del estudiante
        </h2>
  
        <p>
          Datos registrados en el expediente.
        </p>
  
      </div>
  
  
      <div class="profile-actions">
  
        @if (!isEditing) {
  
          <button
            type="button"
            class="profile-edit-button"
            (click)="startEdit()"
          >
            Editar información
          </button>
  
        } @else {
  
          <button
            type="button"
            class="profile-cancel-button"
            [disabled]="isSaving"
            (click)="cancelEdit()"
          >
            Cancelar
          </button>
  
          <button
            type="button"
            class="profile-save-button"
            [disabled]="isSaving"
            (click)="saveStudent()"
          >
            @if (isSaving) {
              Guardando...
            } @else {
              Guardar cambios
            }
          </button>
  
        }
  
      </div>
  
    </div>
  
  
    @if (profileError) {
  
      <div class="profile-message profile-message-error">
        {{ profileError }}
      </div>
  
    }
  
  
    @if (profileSuccess) {
  
      <div class="profile-message profile-message-success">
        {{ profileSuccess }}
      </div>
  
    }
  
  
    @if (!isEditing) {
  
      <!-- =========================
           MODO LECTURA
      ========================== -->
  
      <div class="info-grid">
  
        <div class="info-item">
          <span>
            Folio de expediente
          </span>
          <strong style="font-family: monospace; font-weight: 750; color: #1e3a8a;">
            {{ student.folio || '—' }}
          </strong>
        </div>

        <div class="info-item">
          <span>
            Fecha de emisión de expediente
          </span>
          <strong>
            {{ student.fechaEmisionExpediente ? (student.fechaEmisionExpediente | date:'medium') : 'N/A' }}
          </strong>
        </div>

        <div class="info-item">
          <span>
            Fecha de aceptación / expedición
          </span>
          <strong [style.color]="student.accountStatus === 'active' ? '#059669' : '#64748b'">
            {{ (student.fechaAceptacionExpediente || student.fechaExpedicionExpediente) ? ((student.fechaAceptacionExpediente || student.fechaExpedicionExpediente) | date:'medium') : (student.accountStatus === 'pending' ? 'Pendiente de aceptación' : 'N/A') }}
          </strong>
        </div>

        <div class="info-item">
          <span>
            Tiempo de llenado de formulario
          </span>
          <strong>
            {{ student.tiempoLlenadoMinutosExpediente !== undefined && student.tiempoLlenadoMinutosExpediente !== null ? student.tiempoLlenadoMinutosExpediente + ' min' : 'N/A' }}
          </strong>
        </div>

        <div class="info-item">
  
          <span>
            Nombre completo
          </span>
  
          <strong>
            {{ student.fullName || 'N/A' }}
          </strong>
  
        </div>
  
  
        <div class="info-item">
  
          <span>
            Matrícula
          </span>
  
          <strong>
            {{ student.matricula || 'N/A' }}
          </strong>
  
        </div>
  
  
        <div class="info-item">
  
          <span>
            Correo personal
          </span>
  
          <strong>
            {{ student.mail || 'N/A' }}
          </strong>
  
        </div>
  
  
        <div class="info-item">
  
          <span>
            Correo institucional
          </span>
  
          <strong>
            {{ student.schoolMail || 'N/A' }}
          </strong>
  
        </div>
  
  
        <div class="info-item">
  
          <span>
            Teléfono
          </span>
  
          <strong>
            {{ student.phone || 'N/A' }}
          </strong>
  
        </div>

        <div class="info-item">
          <span>
            Cómo supiste de ABAQ
          </span>
        
          <strong>
            {{ student.comoSupisteDeAbaq || 'N/A' }}
          </strong>
        </div>
  
  
        <div class="info-item">
  
          <span>
            Escuela
          </span>
  
          <strong>
            {{ student.school || 'N/A' }}
          </strong>
  
        </div>
  
  
        <div class="info-item">
  
          <span>
            Carrera
          </span>
  
          <strong>
            {{ student.career || 'N/A' }}
          </strong>
  
        </div>
  
  
        <div class="info-item">
          <span>
            CURP
          </span>
          <strong style="text-transform: uppercase;">
            {{ student.curp || 'N/A' }}
          </strong>
        </div>

        <div class="info-item">
          <span>
            Periodo / Avance académico
          </span>
          <strong>
            {{ student.semester || 'N/A' }}
          </strong>
        </div>
  
  
        <div class="info-item">
  
          <span>
            Auditor
          </span>
  
          <strong>
            {{ student.auditorName || 'N/A' }}
          </strong>
  
        </div>
  
  
        <div class="info-item">
  
          <span>
            Fecha de nacimiento
          </span>
  
          <strong>
            {{ student.birthDate | date:'mediumDate' }}
          </strong>
  
        </div>
  
  
        <div class="info-item">
          <span>
            Fecha de inicio del servicio social
          </span>
          <strong>
            {{
              student.periods.length
                ? (student.periods[0].begin | date:'mediumDate')
                : 'N/A'
            }}
          </strong>
          <span style="font-size: 11px; color: #64748b; margin-top: 2px; display: block; font-weight: 500;">
            Inicio formal en ABAQ (no el inicio de tu carrera)
          </span>
        </div>

        <div class="info-item">
          <span>
            Fecha de conclusión del servicio social
          </span>
          <strong>
            {{
              student.periods.length
                ? (student.periods[0].end | date:'mediumDate')
                : 'N/A'
            }}
          </strong>
          <span style="font-size: 11px; color: #64748b; margin-top: 2px; display: block; font-weight: 500;">
            Límite para acreditar horas (no el fin de tu carrera)
          </span>
        </div>
  
  
        <div class="info-item">
  
          <span>
            Horas requeridas
          </span>
  
          <strong>
            {{
              student.periods.length
                ? student.periods[0].desiredHours
                : 0
            }}
          </strong>
  
        </div>

        <div class="info-item social-info-item">
          <div class="social-icon fb" title="Facebook">
            <svg class="lucide lucide-facebook" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
            </svg>
          </div>
          <div>
            <span>Facebook</span>
            <strong>{{ student.socialMedia.facebook || 'N/A' }}</strong>
          </div>
        </div>


        <div class="info-item social-info-item">
          <div class="social-icon ig" title="Instagram">
            <svg class="lucide lucide-instagram" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect width="20" height="20" x="2" y="2" rx="5" ry="5"/>
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
              <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
            </svg>
          </div>
          <div>
            <span>Instagram</span>
            <strong>{{ student.socialMedia.instagram || 'N/A' }}</strong>
          </div>
        </div>


        <div class="info-item social-info-item">
          <div class="social-icon tk" title="TikTok">
            <svg class="lucide lucide-tiktok" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5"/>
            </svg>
          </div>
          <div>
            <span>TikTok</span>
            <strong>{{ student.socialMedia.tiktok || 'N/A' }}</strong>
          </div>
        </div>


        <div class="info-item social-info-item">
          <div class="social-icon x" title="X (Twitter)">
            <svg class="lucide lucide-twitter" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4l11.733 16h4.267l-11.733 -16z"/>
              <path d="M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772"/>
            </svg>
          </div>
          <div>
            <span>X</span>
            <strong>{{ student.socialMedia.x || 'N/A' }}</strong>
          </div>
        </div>


        <div class="info-item social-info-item">
          <div class="social-icon yt" title="YouTube">
            <svg class="lucide lucide-youtube" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17"/>
              <polygon points="10 15 15 12 10 9 10 15"/>
            </svg>
          </div>
          <div>
            <span>YouTube</span>
            <strong>{{ student.socialMedia.youtube || 'N/A' }}</strong>
          </div>
        </div>


        <div class="info-item social-info-item">
          <div class="social-icon li" title="LinkedIn">
            <svg class="lucide lucide-linkedin" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
              <rect width="4" height="12" x="2" y="9"/>
              <circle cx="4" cy="4" r="2"/>
            </svg>
          </div>
          <div>
            <span>LinkedIn</span>
            <strong>{{ student.socialMedia.linkedin || 'N/A' }}</strong>
          </div>
        </div>
  
      </div>
  
    } @else {
  
      <!-- =========================
           MODO EDICIÓN
      ========================== -->
  
      <form
        class="profile-form"
        [formGroup]="studentForm"
        (ngSubmit)="saveStudent()"
      >
  
        <div class="profile-form-grid">
  
          <!-- FOLIO (NO EDITABLE) -->
          <div class="profile-field">
            <label for="studentFolio">
              Folio de expediente (Inmutable)
            </label>
            <input
              id="studentFolio"
              type="text"
              [value]="student.folio || '—'"
              disabled
              style="font-family: monospace; font-weight: 700; color: #1e3a8a; background: #f8fafc; cursor: not-allowed;"
            />
          </div>

          <!-- NOMBRE -->
          <div class="profile-field">
  
            <label for="fullName">
              Nombre completo
            </label>
  
            <input
              id="fullName"
              type="text"
              formControlName="fullName"
            />
  
            @if (
              studentForm.controls.fullName.touched &&
              studentForm.controls.fullName.invalid
            ) {
              <small>
                El nombre es obligatorio.
              </small>
            }
  
          </div>
  
  
          <!-- MATRÍCULA -->
          <div class="profile-field">
  
            <label for="matricula">
              Matrícula
            </label>
  
            <input
              id="matricula"
              type="text"
              formControlName="matricula"
            />
  
            @if (
              studentForm.controls.matricula.touched &&
              studentForm.controls.matricula.invalid
            ) {
              <small>
                La matrícula es obligatoria.
              </small>
            }
  
          </div>
  
  
          <!-- CORREO PERSONAL -->
          <div class="profile-field">
  
            <label for="mail">
              Correo personal
            </label>
  
            <input
              id="mail"
              type="email"
              formControlName="mail"
            />
  
            @if (
              studentForm.controls.mail.touched &&
              studentForm.controls.mail.invalid
            ) {
              <small>
                Ingresa un correo válido.
              </small>
            }
  
          </div>
  
  
          <!-- CORREO INSTITUCIONAL -->
          <div class="profile-field">
  
            <label for="schoolMail">
              Correo institucional
            </label>
  
            <input
              id="schoolMail"
              type="email"
              formControlName="schoolMail"
            />
  
            @if (
              studentForm.controls.schoolMail.touched &&
              studentForm.controls.schoolMail.invalid
            ) {
              <small>
                Ingresa un correo institucional válido.
              </small>
            }
  
          </div>
  
  
          <!-- TELÉFONO -->
          <div class="profile-field">
  
            <label for="phone">
              Teléfono
            </label>
  
            <input
              id="phone"
              type="text"
              formControlName="phone"
            />
  
            @if (
              studentForm.controls.phone.touched &&
              studentForm.controls.phone.invalid
            ) {
              <small>
                El teléfono es obligatorio.
              </small>
            }
  
          </div>
  

          <!-- CÓMO SUPISTE DE ABAQ -->
          <div class="profile-field">
            <label for="comoSupisteDeAbaq">
              ¿Cómo supiste de ABAQ?
            </label>

            <input
              id="comoSupisteDeAbaq"
              type="text"
              formControlName="comoSupisteDeAbaq"
              placeholder="Evento, redes, medios, referido..."
            />
          </div>

          <!-- SEMBLANZA / BIO PERSONAL -->
          <div class="profile-field" style="grid-column: 1 / -1;">
            <label for="bioPersonal">
              Semblanza / Bio personal
            </label>
            <textarea
              id="bioPersonal"
              rows="3"
              formControlName="bioPersonal"
              placeholder="Semblanza personal y trayectoria..."
              style="width: 100%; padding: 10px 14px; border: 1.5px solid #cbd5e1; border-radius: 8px; font-size: 14px; line-height: 1.5;"
            ></textarea>
          </div>
  
          <!-- ESCUELA -->
          <div class="profile-field">
  
            <label for="school">
              Escuela
            </label>
  
            <input
              id="school"
              type="text"
              formControlName="school"
            />
  
            @if (
              studentForm.controls.school.touched &&
              studentForm.controls.school.invalid
            ) {
              <small>
                La escuela es obligatoria.
              </small>
            }
  
          </div>
  
  
          <!-- CARRERA -->
          <div class="profile-field">
  
            <label for="career">
              Carrera
            </label>
  
            <input
              id="career"
              type="text"
              formControlName="career"
            />
  
            @if (
              studentForm.controls.career.touched &&
              studentForm.controls.career.invalid
            ) {
              <small>
                La carrera es obligatoria.
              </small>
            }
  
          </div>
  
  
          <!-- SEMESTRE -->
          <div class="profile-field">
  
            <label for="semester">
              Semestre
            </label>
  
            <input
              id="semester"
              type="number"
              min="1"
              max="12"
              formControlName="semester"
            />
  
            @if (
              studentForm.controls.semester.touched &&
              studentForm.controls.semester.invalid
            ) {
              <small>
                El semestre debe estar entre 1 y 12.
              </small>
            }
  
          </div>
  
  
          <!-- AUDITOR -->
          <div class="profile-field">
  
            <label for="auditorName">
              Auditor
            </label>
  
            <input
              id="auditorName"
              type="text"
              formControlName="auditorName"
            />
  
          </div>
  
  
          <!-- FECHA NACIMIENTO -->
          <div class="profile-field">
  
            <label for="birthDate">
              Fecha de nacimiento
            </label>
  
            <app-custom-datepicker
              id="birthDate"
              formControlName="birthDate"
              placeholder="Selecciona la fecha de nacimiento"
            ></app-custom-datepicker>
  
            @if (
              studentForm.controls.birthDate.touched &&
              studentForm.controls.birthDate.invalid
            ) {
              <small>
                La fecha de nacimiento es obligatoria.
              </small>
            }
  
          </div>
  
  
          <!-- HORAS REQUERIDAS -->
          <div class="profile-field">
  
            <label for="desiredHours">
              Horas requeridas
            </label>
  
            <input
              id="desiredHours"
              type="number"
              min="1"
              formControlName="desiredHours"
            />
  
            @if (
              studentForm.controls.desiredHours.touched &&
              studentForm.controls.desiredHours.invalid
            ) {
              <small>
                Ingresa una cantidad válida de horas.
              </small>
            }
  
          </div>
  
  
          <!-- FECHA INICIO -->
          <!-- FECHA INICIO DEL SERVICIO SOCIAL -->
          <div class="profile-field">
            <label for="beginDate">
              Fecha de inicio del servicio social <span class="text-required">*</span>
            </label>
            <app-custom-datepicker
              id="beginDate"
              formControlName="beginDate"
              placeholder="DD/MM/AAAA"
            ></app-custom-datepicker>
            <span style="font-size: 11.5px; color: #64748b; margin-top: 4px; display: block; line-height: 1.4;">
              Indica la fecha en que comienzas formalmente tu servicio social en ABAQ (no la fecha de inicio de tu carrera universitaria).
            </span>
            @if (
              studentForm.controls.beginDate.touched &&
              studentForm.controls.beginDate.invalid
            ) {
              <small>
                La fecha de inicio del servicio social es obligatoria.
              </small>
            }
          </div>

          <!-- FECHA FIN DEL SERVICIO SOCIAL -->
          <div class="profile-field">
            <label for="endDate">
              Fecha de conclusión del servicio social
            </label>
            <app-custom-datepicker
              id="endDate"
              formControlName="endDate"
              placeholder="DD/MM/AAAA"
            ></app-custom-datepicker>
            <span style="font-size: 11.5px; color: #64748b; margin-top: 4px; display: block; line-height: 1.4;">
              Indica la fecha límite en que debes acabar y acreditar tus horas de servicio social en ABAQ (no el fin de tu carrera).
            </span>
          </div>

                    <!-- REDES SOCIALES -->
                    <div class="profile-field">

                      <label for="facebookUsuario" style="display: flex; align-items: center; gap: 6px;">
                        <svg class="lucide lucide-facebook" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                        </svg>
                        <span>Facebook</span>
                      </label>
          
                      <input
                        id="facebookUsuario"
                        type="text"
                        formControlName="facebookUsuario"
                        placeholder="Usuario de Facebook"
                      />
          
                    </div>
          
          
                    <div class="profile-field">
          
                      <label for="instagramUsuario" style="display: flex; align-items: center; gap: 6px;">
                        <svg class="lucide lucide-instagram" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <rect width="20" height="20" x="2" y="2" rx="5" ry="5"/>
                          <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                          <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
                        </svg>
                        <span>Instagram</span>
                      </label>
          
                      <input
                        id="instagramUsuario"
                        type="text"
                        formControlName="instagramUsuario"
                        placeholder="Usuario de Instagram"
                      />
          
                    </div>
          
          
                    <div class="profile-field">
          
                      <label for="tiktokUsuario" style="display: flex; align-items: center; gap: 6px;">
                        <svg class="lucide lucide-tiktok" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5"/>
                        </svg>
                        <span>TikTok</span>
                      </label>
          
                      <input
                        id="tiktokUsuario"
                        type="text"
                        formControlName="tiktokUsuario"
                        placeholder="Usuario de TikTok"
                      />
          
                    </div>
          
          
                    <div class="profile-field">
          
                      <label for="xUsuario" style="display: flex; align-items: center; gap: 6px;">
                        <svg class="lucide lucide-twitter" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M4 4l11.733 16h4.267l-11.733 -16z"/>
                          <path d="M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772"/>
                        </svg>
                        <span>X (Twitter)</span>
                      </label>
          
                      <input
                        id="xUsuario"
                        type="text"
                        formControlName="xUsuario"
                        placeholder="Usuario de X"
                      />
          
                    </div>
          
          
                    <div class="profile-field">
          
                      <label for="youtubeUsuario" style="display: flex; align-items: center; gap: 6px;">
                        <svg class="lucide lucide-youtube" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17"/>
                          <polygon points="10 15 15 12 10 9 10 15"/>
                        </svg>
                        <span>YouTube</span>
                      </label>
          
                      <input
                        id="youtubeUsuario"
                        type="text"
                        formControlName="youtubeUsuario"
                        placeholder="Usuario de YouTube"
                      />
          
                    </div>
          
          
                    <div class="profile-field">
          
                      <label for="linkedinUsuario" style="display: flex; align-items: center; gap: 6px;">
                        <svg class="lucide lucide-linkedin" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
                          <rect width="4" height="12" x="2" y="9"/>
                          <circle cx="4" cy="4" r="2"/>
                        </svg>
                        <span>LinkedIn</span>
                      </label>
          
                      <input
                        id="linkedinUsuario"
                        type="text"
                        formControlName="linkedinUsuario"
                        placeholder="Usuario de LinkedIn"
                      />
          
                    </div>
  
        </div>
  
  
        <!-- Este botón oculto permite Enter / ngSubmit -->
        <button
          type="submit"
          hidden
          [disabled]="isSaving"
        ></button>
  
      </form>
  
    }
  
  </section>
  
  
        <!-- =========================================
             DOCUMENTOS
        ========================================== -->
  
        <!-- =========================================
             DOCUMENTOS DEL EXPEDIENTE (ENLACES EN LA NUBE)
        ========================================== -->

        <section class="detail-card">
          <div class="section-title">
            <div>
              <span class="section-kicker">EXPEDIENTE DIGITAL</span>
              <h2>Documentos del expediente en la nube</h2>
              <p>Enlaces y archivos compartidos durante el registro institucional.</p>
            </div>
          </div>

          @if (documentActionSuccess) {
            <div class="document-success-alert" style="margin-bottom: 18px;">
              <span class="material-symbols-outlined">check_circle</span>
              <span>{{ documentActionSuccess }}</span>
            </div>
          }

          @if (documentError) {
            <div class="document-error" style="margin-bottom: 18px;">
              <span class="material-symbols-outlined">error</span>
              <span>{{ documentError }}</span>
            </div>
          }

          <!-- SUBGRUPO 1: SERVICIO SOCIAL -->
          <div style="margin-bottom: 26px;">
            <div style="margin-bottom: 12px;">
              <h3 style="margin: 0 0 3px; font-size: 14px; font-weight: 750; color: #1e3a8a;">
                Documentación Institucional de Servicio Social
              </h3>
              <span style="font-size: 12px; color: #64748b;">
                Cartas y constancias del ciclo reglamentario de 480 horas
              </span>
            </div>

            <div class="info-grid doc-info-grid">
              <!-- CONSTANCIA DE PLÁTICA -->
              <article class="info-card">
                <span>CONSTANCIA DE PLÁTICA DE INDUCCIÓN</span>
                @if (hasValidDocument(student.constanciaPlatica)) {
                  <strong style="margin-bottom: 8px; font-size: 13px; color: #166534;">✓ Enlace disponible</strong>
                  <div style="display: flex; gap: 8px; flex-wrap: wrap;">
                    <button
                      type="button"
                      style="padding: 7px 12px; border-radius: 8px; border: 1px solid #1e40af; background: #1e40af; color: white; font-size: 11px; font-weight: 700; cursor: pointer;"
                      (click)="openDocument(student.constanciaPlatica)"
                    >
                      Abrir en pestaña nueva ↗
                    </button>
                    <button
                      type="button"
                      style="padding: 7px 12px; border-radius: 8px; border: 1px solid #cbd5e1; background: #f8fafc; color: #334155; font-size: 11px; font-weight: 700; cursor: pointer;"
                      (click)="openEditDocumentLinkModal('constanciaPlatica')"
                    >
                      Editar enlace ✏️
                    </button>
                  </div>
                } @else {
                  <span style="color: #94a3b8; font-weight: 600; font-size: 13px; margin-bottom: 8px; display: block;">No proporcionado</span>
                  <button
                    type="button"
                    style="padding: 7px 12px; border-radius: 8px; border: 1px solid #cbd5e1; background: #f8fafc; color: #334155; font-size: 11px; font-weight: 700; cursor: pointer;"
                    (click)="openEditDocumentLinkModal('constanciaPlatica')"
                  >
                    + Agregar enlace
                  </button>
                }
              </article>

              <!-- REPORTE DE ACTIVIDADES -->
              <article class="info-card">
                <span>REPORTE DE ACTIVIDADES</span>
                @if (hasValidDocument(student.reporteActividades)) {
                  <strong style="margin-bottom: 8px; font-size: 13px; color: #166534;">✓ Enlace disponible</strong>
                  <div style="display: flex; gap: 8px; flex-wrap: wrap;">
                    <button
                      type="button"
                      style="padding: 7px 12px; border-radius: 8px; border: 1px solid #1e40af; background: #1e40af; color: white; font-size: 11px; font-weight: 700; cursor: pointer;"
                      (click)="openDocument(student.reporteActividades)"
                    >
                      Abrir en pestaña nueva ↗
                    </button>
                    <button
                      type="button"
                      style="padding: 7px 12px; border-radius: 8px; border: 1px solid #cbd5e1; background: #f8fafc; color: #334155; font-size: 11px; font-weight: 700; cursor: pointer;"
                      (click)="openEditDocumentLinkModal('reporteActividades')"
                    >
                      Editar enlace ✏️
                    </button>
                  </div>
                } @else {
                  <span style="color: #94a3b8; font-weight: 600; font-size: 13px; margin-bottom: 8px; display: block;">No proporcionado</span>
                  <button
                    type="button"
                    style="padding: 7px 12px; border-radius: 8px; border: 1px solid #cbd5e1; background: #f8fafc; color: #334155; font-size: 11px; font-weight: 700; cursor: pointer;"
                    (click)="openEditDocumentLinkModal('reporteActividades')"
                  >
                    + Agregar enlace
                  </button>
                }
              </article>

              <!-- CARTA DE TÉRMINO -->
              <article class="info-card">
                <span>CARTA DE TÉRMINO (LIBERACIÓN)</span>
                @if (hasValidDocument(student.cartaTermino)) {
                  <strong style="margin-bottom: 8px; font-size: 13px; color: #166534;">✓ Enlace disponible</strong>
                  <div style="display: flex; gap: 8px; flex-wrap: wrap;">
                    <button
                      type="button"
                      style="padding: 7px 12px; border-radius: 8px; border: 1px solid #1e40af; background: #1e40af; color: white; font-size: 11px; font-weight: 700; cursor: pointer;"
                      (click)="openDocument(student.cartaTermino)"
                    >
                      Abrir en pestaña nueva ↗
                    </button>
                    <button
                      type="button"
                      style="padding: 7px 12px; border-radius: 8px; border: 1px solid #cbd5e1; background: #f8fafc; color: #334155; font-size: 11px; font-weight: 700; cursor: pointer;"
                      (click)="openEditDocumentLinkModal('cartaTermino')"
                    >
                      Editar enlace ✏️
                    </button>
                  </div>
                } @else {
                  <span style="color: #94a3b8; font-weight: 600; font-size: 13px; margin-bottom: 8px; display: block;">No proporcionado</span>
                  <button
                    type="button"
                    style="padding: 7px 12px; border-radius: 8px; border: 1px solid #cbd5e1; background: #f8fafc; color: #334155; font-size: 11px; font-weight: 700; cursor: pointer;"
                    (click)="openEditDocumentLinkModal('cartaTermino')"
                  >
                    + Agregar enlace
                  </button>
                }
              </article>
            </div>
          </div>

          <!-- SUBGRUPO 2: ONBOARDING / IDENTIDAD (FASE 4) -->
          <div>
            <div style="margin-bottom: 12px;">
              <h3 style="margin: 0 0 3px; font-size: 14px; font-weight: 750; color: #1e3a8a;">
                Documentos de Registro e Identidad (Onboarding)
              </h3>
              <span style="font-size: 12px; color: #64748b;">
                Enlaces compartidos durante el registro del expediente institucional
              </span>
            </div>

            <div class="info-grid doc-info-grid">
              <!-- IDENTIFICACIÓN OFICIAL (INE) -->
              <article class="info-card">
                <span>IDENTIFICACIÓN OFICIAL (INE / ESCOLAR)</span>
                @if (hasValidDocument(student.cloudUrls?.ine)) {
                  <strong style="margin-bottom: 8px; font-size: 13px; color: #166534;">✓ Enlace disponible</strong>
                  <div style="display: flex; gap: 8px; flex-wrap: wrap;">
                    <button
                      type="button"
                      style="padding: 7px 12px; border-radius: 8px; border: 1px solid #1e40af; background: #1e40af; color: white; font-size: 11px; font-weight: 700; cursor: pointer;"
                      (click)="openDocument(student.cloudUrls?.ine)"
                    >
                      Abrir en pestaña nueva ↗
                    </button>
                    <button
                      type="button"
                      style="padding: 7px 12px; border-radius: 8px; border: 1px solid #cbd5e1; background: #f8fafc; color: #334155; font-size: 11px; font-weight: 700; cursor: pointer;"
                      (click)="openEditDocumentLinkModal('ine')"
                    >
                      Editar enlace ✏️
                    </button>
                  </div>
                } @else {
                  <span style="color: #94a3b8; font-weight: 600; font-size: 13px; margin-bottom: 8px; display: block;">No proporcionado</span>
                  <button
                    type="button"
                    style="padding: 7px 12px; border-radius: 8px; border: 1px solid #cbd5e1; background: #f8fafc; color: #334155; font-size: 11px; font-weight: 700; cursor: pointer;"
                    (click)="openEditDocumentLinkModal('ine')"
                  >
                    + Agregar enlace
                  </button>
                }
              </article>

              <!-- CURRÍCULUM VITAE (CV) -->
              <article class="info-card">
                <span>CURRÍCULUM VITAE (CV) / SEMBLANZA</span>
                @if (hasValidDocument(student.cloudUrls?.cv)) {
                  <strong style="margin-bottom: 8px; font-size: 13px; color: #166534;">✓ Enlace disponible</strong>
                  <div style="display: flex; gap: 8px; flex-wrap: wrap;">
                    <button
                      type="button"
                      style="padding: 7px 12px; border-radius: 8px; border: 1px solid #1e40af; background: #1e40af; color: white; font-size: 11px; font-weight: 700; cursor: pointer;"
                      (click)="openDocument(student.cloudUrls?.cv)"
                    >
                      Abrir en pestaña nueva ↗
                    </button>
                    <button
                      type="button"
                      style="padding: 7px 12px; border-radius: 8px; border: 1px solid #cbd5e1; background: #f8fafc; color: #334155; font-size: 11px; font-weight: 700; cursor: pointer;"
                      (click)="openEditDocumentLinkModal('cv')"
                    >
                      Editar enlace ✏️
                    </button>
                  </div>
                } @else {
                  <span style="color: #94a3b8; font-weight: 600; font-size: 13px; margin-bottom: 8px; display: block;">No proporcionado</span>
                  <button
                    type="button"
                    style="padding: 7px 12px; border-radius: 8px; border: 1px solid #cbd5e1; background: #f8fafc; color: #334155; font-size: 11px; font-weight: 700; cursor: pointer;"
                    (click)="openEditDocumentLinkModal('cv')"
                  >
                    + Agregar enlace
                  </button>
                }
              </article>

              <!-- COMPROBANTE -->
              <article class="info-card">
                <span>COMPROBANTE DE DOMICILIO O ESTUDIOS</span>
                @if (hasValidDocument(student.cloudUrls?.comprobante)) {
                  <strong style="margin-bottom: 8px; font-size: 13px; color: #166534;">✓ Enlace disponible</strong>
                  <div style="display: flex; gap: 8px; flex-wrap: wrap;">
                    <button
                      type="button"
                      style="padding: 7px 12px; border-radius: 8px; border: 1px solid #1e40af; background: #1e40af; color: white; font-size: 11px; font-weight: 700; cursor: pointer;"
                      (click)="openDocument(student.cloudUrls?.comprobante)"
                    >
                      Abrir en pestaña nueva ↗
                    </button>
                    <button
                      type="button"
                      style="padding: 7px 12px; border-radius: 8px; border: 1px solid #cbd5e1; background: #f8fafc; color: #334155; font-size: 11px; font-weight: 700; cursor: pointer;"
                      (click)="openEditDocumentLinkModal('comprobante')"
                    >
                      Editar enlace ✏️
                    </button>
                  </div>
                } @else {
                  <span style="color: #94a3b8; font-weight: 600; font-size: 13px; margin-bottom: 8px; display: block;">No proporcionado</span>
                  <button
                    type="button"
                    style="padding: 7px 12px; border-radius: 8px; border: 1px solid #cbd5e1; background: #f8fafc; color: #334155; font-size: 11px; font-weight: 700; cursor: pointer;"
                    (click)="openEditDocumentLinkModal('comprobante')"
                  >
                    + Agregar enlace
                  </button>
                }
              </article>
            </div>
          </div>
        </section>

        <!-- =========================================
             CONSTANCIA OFICIAL DE ACEPTACIÓN
        ========================================== -->
        @if (student.accountStatus === 'active' || hasValidDocument(student.cartaAceptacion)) {
          <section class="detail-card" style="margin-top: 24px;">
            <div class="section-title">
              <div>
                <span class="section-kicker">DOCUMENTO OFICIAL</span>
                <h2>Constancia oficial de aceptación</h2>
                <p>Constancia oficial emitida por ABAQ con sello criptográfico HMAC-SHA256.</p>
              </div>
            </div>

            <div style="display: flex; align-items: center; justify-content: space-between; gap: 20px; padding: 20px 24px; border-radius: 14px; background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%); border: 1.5px solid #bfdbfe; flex-wrap: wrap;">
              <div style="display: flex; align-items: center; gap: 16px;">
                <div style="width: 52px; height: 52px; border-radius: 12px; background: #2563eb; color: #ffffff; display: flex; align-items: center; justify-content: center; font-size: 26px;">
                  📄
                </div>
                <div>
                  <h3 style="margin: 0; font-size: 16px; font-weight: 800; color: #1e3a8a;">
                    Carta de Aceptación y Felicitación · Servicio Social
                  </h3>
                  <p style="margin: 4px 0 0; font-size: 13px; color: #2563eb;">
                    Folio: <strong>{{ student.folio }}</strong> · Verificable en línea con QR institucional
                  </p>
                </div>
              </div>

              <div style="display: flex; gap: 10px; align-items: center; flex-wrap: wrap;">
                <button
                  type="button"
                  style="padding: 12px 20px; border-radius: 10px; background: #1d4ed8; color: #ffffff; border: none; font-weight: 750; font-size: 13.5px; cursor: pointer;"
                  (click)="openDocument(student.cartaAceptacion)"
                >
                  Ver y Descargar Constancia ↗
                </button>
                <button
                  type="button"
                  style="padding: 11px 16px; border-radius: 10px; background: #ffffff; color: #1e40af; border: 1px solid #bfdbfe; font-weight: 700; font-size: 13px; cursor: pointer;"
                  (click)="openEditDocumentLinkModal('cartaAceptacion')"
                >
                  Editar enlace ✏️
                </button>
              </div>
            </div>
          </section>
        }

        <!-- =========================================
             PERFIL PERSONAL, TALENTOS Y COMPROMISO (FASE 3)
        ========================================== -->
        <section class="detail-card" style="margin-top: 32px;">
          <div class="section-title">
            <div>
              <span class="section-kicker">FASE 3 · SOBRE MÍ</span>
              <h2>Semblanza, Intereses, Talentos y Vocación</h2>
              <p>Perfil vocacional y afinidad al bienestar animal del estudiante.</p>
            </div>
          </div>

          <div class="info-grid">
            <div class="info-item" style="grid-column: 1 / -1;">
              <span>Semblanza / Bio Personal</span>
              <p style="margin: 6px 0 0; font-size: 14px; line-height: 1.6; color: #1e293b; white-space: pre-line;">
                {{ student.bioPersonal || 'Sin semblanza registrada.' }}
              </p>
            </div>

            <div class="info-item">
              <span>Intereses y Pasiones</span>
              <strong>{{ student.intereses || 'No especificados' }}</strong>
            </div>

            <div class="info-item">
              <span>Talentos y Habilidades Especiales</span>
              <strong>{{ student.talentos || 'No especificados' }}</strong>
            </div>

            <div class="info-item">
              <span>Aportes Principales a ABAQ</span>
              <strong>{{ student.aportesAbaq || 'No especificados' }}</strong>
            </div>

            <div class="info-item">
              <span>Experiencia Previa con Animales</span>
              <strong>{{ student.animalExperience ? '✓ Sí: ' + (student.descExperiencia || 'Convivencia') : 'Sin experiencia previa registrada' }}</strong>
            </div>

            <div class="info-item" style="grid-column: 1 / -1;">
              <span>Motivación para Unirse a ABAQ</span>
              <p style="margin: 6px 0 0; font-size: 13.5px; color: #334155;">
                {{ student.motivacionAbaq || 'No especificada' }}
              </p>
            </div>
          </div>

          <!-- ACTIVIDADES PRIORIZADAS -->
          @if (student.rankedActivities && student.rankedActivities.length > 0) {
            <div class="ranked-activities-container">
              <div class="ranked-activities-header">
                <div>
                  <h3 class="ranked-activities-title">
                    🎯 Actividades de servicio social priorizadas por el estudiante
                  </h3>
                  <p class="ranked-activities-subtitle">
                    Orden de preferencia establecido por el estudiante para la asignación de tareas operativas y de campo.
                  </p>
                </div>
                <span class="ranked-activities-count">
                  {{ student.rankedActivities.length }} actividades
                </span>
              </div>

              <div class="ranked-activities-table-wrapper">
                <table class="ranked-activities-table">
                  <thead>
                    <tr>
                      <th class="col-priority"># Prioridad</th>
                      <th class="col-activity">Actividad reglamentaria priorizada</th>
                      <th class="col-accreditation">Acreditación estimada</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (act of student.rankedActivities; track act; let idx = $index) {
                      <tr>
                        <td class="col-priority">
                          <span class="priority-rank-badge">{{ idx + 1 }}</span>
                        </td>
                        <td class="col-activity">
                          <span class="activity-text">{{ getActivityTitle(act) }}</span>
                        </td>
                        <td class="col-accreditation">
                          @if (getActivityHours(act)) {
                            <span class="accreditation-pill">
                              <span class="pill-icon">⏱</span>
                              <span>{{ getActivityHours(act) }}</span>
                            </span>
                          } @else {
                            <span class="no-hours-text">—</span>
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          }
        </section>

        <!-- =========================================
             INDUCCIÓN Y REFLEXIONES (FASE 2)
        ========================================== -->
        <section class="detail-card" style="margin-top: 32px;">
          <div class="section-title">
            <div>
              <span class="section-kicker">FASE 2 · INDUCCIÓN</span>
              <h2>Reflexiones de los 6 Módulos Formativos</h2>
              <p>Respuestas registradas durante la inducción institucional sobre rescate, valores y misión de ABAQ.</p>
            </div>
          </div>

          @if (hasAnyReflections()) {
            <div style="display: flex; flex-direction: column; gap: 16px;">
              @for (mod of reflectionsList; track mod.id) {
                <div style="padding: 16px 20px; border-radius: 12px; background: #f8fafc; border: 1px solid #e2e8f0;">
                  <h4 style="margin: 0 0 10px; font-size: 14.5px; font-weight: 800; color: #24366f;">
                    {{ mod.name }}
                  </h4>
                  @if (mod.data) {
                    <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 14px; font-size: 13px;">
                      <div style="background: #ffffff; padding: 12px; border-radius: 8px; border: 1px solid #e2e8f0;">
                        <span style="display: block; font-weight: 750; color: #059669; margin-bottom: 4px;">❤️ Lo que más llamó mi atención:</span>
                        <p style="margin: 0; color: #334155; line-height: 1.4;">{{ mod.data.liked || 'Sin respuesta' }}</p>
                      </div>
                      <div style="background: #ffffff; padding: 12px; border-radius: 8px; border: 1px solid #e2e8f0;">
                        <span style="display: block; font-weight: 750; color: #2563eb; margin-bottom: 4px;">⭐ Lo que considero más importante:</span>
                        <p style="margin: 0; color: #334155; line-height: 1.4;">{{ mod.data.important || 'Sin respuesta' }}</p>
                      </div>
                      <div style="background: #ffffff; padding: 12px; border-radius: 8px; border: 1px solid #e2e8f0;">
                        <span style="display: block; font-weight: 750; color: #d97706; margin-bottom: 4px;">💡 Sugerencia de mejora / propuesta:</span>
                        <p style="margin: 0; color: #334155; line-height: 1.4;">{{ mod.data.improve || 'Sin respuesta' }}</p>
                      </div>
                    </div>
                  } @else {
                    <span style="font-size: 12.5px; color: #94a3b8; font-style: italic;">Módulo sin respuestas registradas.</span>
                  }
                </div>
              }
            </div>
          } @else {
            <div style="padding: 24px; text-align: center; border-radius: 12px; background: #f8fafc; border: 1px dashed #cbd5e1; color: #64748b;">
              Sin reflexiones de inducción registradas para este estudiante.
            </div>
          }
        </section>

        <!-- =========================================
             CONSENTIMIENTOS NORMATIVOS (FASE 4)
        ========================================== -->
        <section class="detail-card" style="margin-top: 32px;">
          <div class="section-title">
            <div>
              <span class="section-kicker">NORMATIVA Y CUMPLIMIENTO</span>
              <h2>Consentimientos y Términos Aceptados</h2>
              <p>Condiciones y normativas validadas por el estudiante durante el registro.</p>
            </div>
          </div>

          <div class="consent-grid">
            <a
              [href]="getLegalDocUrl('reglamento')"
              (click)="openLegalDoc('reglamento', $event)"
              target="_blank"
              rel="noopener noreferrer"
              class="consent-doc-link"
              title="Abrir Reglamento General Interno en otra pestaña"
            >
              <div class="consent-left">
                <span class="consent-status-icon">{{ student.consents?.reglamento ? '✅' : '❌' }}</span>
                <span class="consent-title">Reglamento General Interno</span>
              </div>
              <span class="material-symbols-outlined consent-ext-icon">open_in_new</span>
            </a>

            <a
              [href]="getLegalDocUrl('privacidad')"
              (click)="openLegalDoc('privacidad', $event)"
              target="_blank"
              rel="noopener noreferrer"
              class="consent-doc-link"
              title="Abrir Aviso de Privacidad Integral en otra pestaña"
            >
              <div class="consent-left">
                <span class="consent-status-icon">{{ student.consents?.privacidad ? '✅' : '❌' }}</span>
                <span class="consent-title">Aviso de Privacidad Integral</span>
              </div>
              <span class="material-symbols-outlined consent-ext-icon">open_in_new</span>
            </a>

            <a
              [href]="getLegalDocUrl('etica')"
              (click)="openLegalDoc('etica', $event)"
              target="_blank"
              rel="noopener noreferrer"
              class="consent-doc-link"
              title="Abrir Código de Ética y Conducta en otra pestaña"
            >
              <div class="consent-left">
                <span class="consent-status-icon">{{ student.consents?.etica ? '✅' : '❌' }}</span>
                <span class="consent-title">Código de Ética y Conducta</span>
              </div>
              <span class="material-symbols-outlined consent-ext-icon">open_in_new</span>
            </a>

            <a
              [href]="getLegalDocUrl('incognito')"
              (click)="openLegalDoc('incognito', $event)"
              target="_blank"
              rel="noopener noreferrer"
              class="consent-doc-link"
              title="Abrir Permiso de Difusión Institucional en otra pestaña"
            >
              <div class="consent-left">
                <span class="consent-status-icon">{{ student.consents?.incognito ? '✅' : '❌' }}</span>
                <span class="consent-title">Permiso de Difusión Institucional</span>
              </div>
              <span class="material-symbols-outlined consent-ext-icon">open_in_new</span>
            </a>

            <a
              [href]="getLegalDocUrl('consentimiento')"
              (click)="openLegalDoc('consentimiento', $event)"
              target="_blank"
              rel="noopener noreferrer"
              class="consent-doc-link"
              title="Abrir Consentimiento Voluntario Expreso en otra pestaña"
            >
              <div class="consent-left">
                <span class="consent-status-icon">{{ student.consents?.consentimiento ? '✅' : '❌' }}</span>
                <span class="consent-title">Consentimiento Voluntario Expreso</span>
              </div>
              <span class="material-symbols-outlined consent-ext-icon">open_in_new</span>
            </a>
          </div>
        </section>
  
              <!-- =========================================
           PESTAÑAS: ACREDITACIONES / ACTIVIDADES / TODAS
      ========================================== -->

      <nav class="sd-tabs" role="tablist">
        <button
          type="button"
          role="tab"
          class="sd-tab"
          [class.active]="accActiveTab === 'acreditaciones'"
          [attr.aria-selected]="accActiveTab === 'acreditaciones'"
          (click)="setAccTab('acreditaciones')"
        >
          Acreditaciones
          <span class="sd-tab-count">{{ accreditations.length }}</span>
        </button>
        <button
          type="button"
          role="tab"
          class="sd-tab"
          [class.active]="accActiveTab === 'actividades'"
          [attr.aria-selected]="accActiveTab === 'actividades'"
          (click)="setAccTab('actividades')"
        >
          Actividades
          <span class="sd-tab-count">{{ student.assignedActivities.length }}</span>
        </button>
        <button
          type="button"
          role="tab"
          class="sd-tab"
          [class.active]="accActiveTab === 'todas'"
          [attr.aria-selected]="accActiveTab === 'todas'"
          (click)="setAccTab('todas')"
        >
          Todas
          <span class="sd-tab-count">{{
            accreditations.length + student.assignedActivities.length
          }}</span>
        </button>
      </nav>

      <!-- =========================================
           ACREDITACIONES
      ========================================== -->

      @if (accActiveTab === 'acreditaciones') {
      <section class="detail-card accreditation-section">

        <div class="section-title">
          <div>
            <span class="section-kicker">
              Servicio social
            </span>

            <h2>
              Acreditaciones
            </h2>

            <p>
              Registro de horas y actividades acreditadas del estudiante.
            </p>
          </div>

          <div class="activity-count">
            <strong>
              {{ accreditations.length }}
            </strong>

            <span>
              {{ accreditations.length === 1
                ? 'acreditación'
                : 'acreditaciones' }}
            </span>
          </div>
        </div>

        <div class="accreditations-list">

          @for (
            accreditation of accreditations;
            track accreditation._id
          ) {

            <article class="accreditation-card">

              <div class="accreditation-card-header">

                <div>
                  <span class="accreditation-type">
                    @switch (accreditation.type) {
                      @case ('EVENT') {
                        Evento ABAQ
                      }
                      @case ('INDUCTION') {
                        Inducción
                      }
                      @case ('IDENTIFICATION') {
                        Placas de identificación
                      }
                      @case ('STERILIZATION') {
                        Esterilización
                      }
                      @case ('ADOPTION') {
                        Adopción
                      }
                      @case ('ADOPTION_MODULE') {
                        Módulo de adopción
                      }
                      @case ('TALK') {
                        Plática ABAQ
                      }
                      @case ('CAMPAIGN') {
                        Campaña
                      }
                      @case ('MEDIA') {
                        Difusión en medios
                      }
                      @case ('SOCIAL_MEDIA') {
                        Redes sociales
                      }
                      @case ('DONATION') {
                        Recaudación de fondos
                      }
                      @case ('ADMINISTRATIVE') {
                        Actividad administrativa
                      }
                      @default {
                        {{ accreditation.type }}
                      }
                    }
                  </span>

                  <h3>
                    {{ accreditation.date | date:'mediumDate':'UTC' }}
                  </h3>

                  @if (accreditation.interactionFolio) {
                    <div class="accreditation-folio-row">
                      <app-folio-pill
                        [folio]="accreditation.interactionFolio"
                        [interactionType]="accreditation.interactionType || 'AC'"
                        [showHours]="true"
                        [hours]="accreditation.hoursAccredited || 0"
                      ></app-folio-pill>
                    </div>
                  }
                </div>

                <span
                  class="accreditation-status"
                  [class.status-pending]="
                    accreditation.status === 'pending'
                  "
                  [class.status-approved]="
                    accreditation.status === 'approved'
                  "
                  [class.status-rejected]="
                    accreditation.status === 'rejected'
                  "
                >
                  {{ accreditation.status }}
                </span>

              </div>

              <div class="accreditation-meta">

                <div>
                  <span>
                    Horas acreditadas
                  </span>

                  <strong>
                    {{ accreditation.hoursAccredited || 0 }} h
                  </strong>
                </div>

                @if (accreditation.hoursPerformed) {
                  <div>
                    <span>
                      Horas realizadas
                    </span>

                    <strong>
                      {{ accreditation.hoursPerformed }} h
                    </strong>
                  </div>
                }

                @if (accreditation.quantity) {
                  <div>
                    <span>
                      Cantidad
                    </span>

                    <strong>
                      {{ accreditation.quantity }}
                    </strong>
                  </div>
                }

              </div>

              <div class="accreditation-details-toggle">

                <button
                  type="button"
                  class="details-button"
                  (click)="toggleAccreditationDetails(accreditation._id)"
                >
                  {{
                    expandedAccreditationId === accreditation._id
                      ? 'Ocultar detalle'
                      : 'Ver detalle'
                  }}
                </button>
              
              </div>

              @if (
                expandedAccreditationId === accreditation._id &&
                accreditation.type === 'TALK'
              ) {
                <div class="accreditation-expanded-details">

                  <div class="detail-item">
                    <span>Participantes</span>

                    <strong>
                      {{ accreditation.participantsCount || 0 }}
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Fecha de la plática</span>

                    <strong>
                      {{ accreditation.date | date:'mediumDate':'UTC' }}
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Horas acreditadas</span>

                    <strong>
                      {{ accreditation.hoursAccredited || 0 }} h
                    </strong>
                  </div>

                </div>
              }

              @if (
                expandedAccreditationId === accreditation._id &&
                accreditation.type === 'CAMPAIGN'
              ) {
                <div class="accreditation-expanded-details">

                  <div class="detail-item">
                    <span>Animales inscritos</span>

                    <strong>
                      {{ accreditation.animalsEnrolled || 0 }}
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Infraestructura disponible</span>

                    <strong>
                      {{
                        accreditation.infrastructureAvailable
                          ? 'Sí'
                          : 'No'
                      }}
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Horas acreditadas</span>

                    <strong>
                      {{ accreditation.hoursAccredited || 0 }} h
                    </strong>
                  </div>

                </div>
              }


              @if (
                expandedAccreditationId === accreditation._id &&
                accreditation.type === 'ADOPTION'
              ) {
                <div class="accreditation-expanded-details">

                  <div class="detail-item">
                    <span>Cantidad de adopciones</span>

                    <strong>
                      {{ accreditation.quantity || 0 }}
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Inicio del periodo de prueba</span>

                    <strong>
                      {{ accreditation.trialStartDate | date:'mediumDate':'UTC' }}
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Fin del periodo de prueba</span>

                    <strong>
                      {{ accreditation.trialEndDate | date:'mediumDate':'UTC' }}
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Horas acreditadas</span>

                    <strong>
                      {{ accreditation.hoursAccredited || 0 }} h
                    </strong>
                  </div>

                </div>
              }

              @if (
                expandedAccreditationId === accreditation._id &&
                accreditation.type === 'IDENTIFICATION'
              ) {
                <div class="accreditation-expanded-details">

                  <div class="detail-item">
                    <span>Placas gestionadas</span>

                    <strong>
                      {{ accreditation.quantity || 0 }}
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Horas por placa</span>

                    <strong>
                      5 h
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Horas acreditadas</span>

                    <strong>
                      {{ accreditation.hoursAccredited || 0 }} h
                    </strong>
                  </div>

                </div>
              }

              @if (
                expandedAccreditationId === accreditation._id &&
                accreditation.type === 'STERILIZATION'
              ) {
                <div class="accreditation-expanded-details">

                  <div class="detail-item">
                    <span>Esterilizaciones gestionadas</span>

                    <strong>
                      {{ accreditation.quantity || 0 }}
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Horas por esterilización</span>

                    <strong>
                      10 h
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Horas acreditadas</span>

                    <strong>
                      {{ accreditation.hoursAccredited || 0 }} h
                    </strong>
                  </div>

                </div>
              }

              @if (
                expandedAccreditationId === accreditation._id &&
                accreditation.type === 'ADOPTION_MODULE'
              ) {
                <div class="accreditation-expanded-details">

                  <div class="detail-item">
                    <span>Módulos de adopción gestionados</span>

                    <strong>
                      {{ accreditation.quantity || 0 }}
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Horas por módulo</span>

                    <strong>
                      40 h
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Horas acreditadas</span>

                    <strong>
                      {{ accreditation.hoursAccredited || 0 }} h
                    </strong>
                  </div>

                </div>
              }

              @if (
                expandedAccreditationId === accreditation._id &&
                accreditation.type === 'EVENT'
              ) {
                <div class="accreditation-expanded-details">

                  <div class="detail-item">
                    <span>Tipo de evento</span>

                    <strong>
                      {{
                        accreditation.eventType === 'SHELTER_CLEANING'
                          ? 'Limpieza de refugio'
                          : 'Evento general'
                      }}
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Horas realizadas</span>

                    <strong>
                      {{ accreditation.hoursPerformed || 0 }} h
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Factor de acreditación</span>

                    <strong>
                      {{
                        accreditation.eventType === 'SHELTER_CLEANING'
                          ? '4×'
                          : '2×'
                      }}
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Horas acreditadas</span>

                    <strong>
                      {{ accreditation.hoursAccredited || 0 }} h
                    </strong>
                  </div>

                </div>
              }
              
              @if (
                expandedAccreditationId === accreditation._id &&
                accreditation.type === 'INDUCTION'
              ) {
                <div class="accreditation-expanded-details">

                  <div class="detail-item">
                    <span>Tipo</span>

                    <strong>
                      Inducción de Servicio Social
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Horas acreditadas</span>

                    <strong>
                      {{ accreditation.hoursAccredited || 0 }} h
                    </strong>
                  </div>

                </div>
              }

              @if (
                expandedAccreditationId === accreditation._id &&
                accreditation.type === 'SOCIAL_MEDIA'
              ) {
                <div class="accreditation-expanded-details">

                  <div class="detail-item">
                    <span>Reacciones obtenidas</span>

                    <strong>
                      {{ accreditation.reactionsCount || 0 }}
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Horas base</span>

                    <strong>
                      5 h
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Bono por reacciones</span>

                    <strong>
                      {{ Math.floor((accreditation.reactionsCount || 0) / 5) }} h
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Horas acreditadas</span>

                    <strong>
                      {{ accreditation.hoursAccredited || 0 }} h
                    </strong>
                  </div>

                </div>
}


              @if (
                expandedAccreditationId === accreditation._id &&
                accreditation.type === 'MEDIA'
              ) {
                <div class="accreditation-expanded-details">

                  <div class="detail-item">
                    <span>Tipo de actividad</span>

                    <strong>
                      Difusión en medios
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Fecha</span>

                    <strong>
                      {{ accreditation.date | date:'mediumDate':'UTC' }}
                    </strong>
                  </div>

                  <div class="detail-item">
                    <span>Horas acreditadas</span>

                    <strong>
                      {{ accreditation.hoursAccredited || 0 }} h
                    </strong>
                  </div>

                </div>
              }

              @if (
                expandedAccreditationId === accreditation._id &&
                accreditation.type === 'DONATION'
              ) {
                <div class="accreditation-expanded-details">
              
                  <div class="detail-item">
                    <span>Monto recaudado</span>
              
                    <strong>
                      ${{ accreditation.donationAmount || 0 }}
                    </strong>
                  </div>
              
                  <div class="detail-item">
                    <span>Regla de acreditación</span>
              
                    <strong>
                      1 h por cada $50
                    </strong>
                  </div>
              
                  <div class="detail-item">
                    <span>Horas acreditadas</span>
              
                    <strong>
                      {{ accreditation.hoursAccredited || 0 }} h
                    </strong>
                  </div>
              
                </div>
              }

              @if (
                expandedAccreditationId === accreditation._id &&
                accreditation.type === 'ADMINISTRATIVE'
              ) {
                <div class="accreditation-expanded-details">
              
                  <div class="detail-item">
                    <span>Tipo de actividad</span>
              
                    <strong>
                      Actividad administrativa
                    </strong>
                  </div>
              
                  <div class="detail-item">
                    <span>Horas registradas</span>
              
                    <strong>
                      {{ accreditation.hoursAccredited || 0 }} h
                    </strong>
                  </div>
              
                  <div class="detail-item">
                    <span>Horas acreditadas</span>
              
                    <strong>
                      {{ accreditation.hoursAccredited || 0 }} h
                    </strong>
                  </div>
              
                </div>
              }

              @if (expandedAccreditationId === accreditation._id && accreditation.evidenceUrl) {
                <div class="accreditation-evidence">
                  <a
                    [href]="accreditation.evidenceUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="evidence-link"
                  >
                    🔗 Ver evidencia
                  </a>
                </div>
              }

              @if (accreditation.status === 'pending') {
                <div class="accreditation-actions">
              
                  <button
                    type="button"
                    class="reject-accreditation-button"
                    [disabled]="
                      rejectingAccreditationId === accreditation._id ||
                      approvingAccreditationId === accreditation._id
                    "
                    (click)="rejectAccreditation(accreditation._id)"
                  >
                    {{
                      rejectingAccreditationId === accreditation._id
                        ? 'Rechazando...'
                        : 'Rechazar acreditación'
                    }}
                  </button>
              
                  <button
                    type="button"
                    class="approve-accreditation-button"
                    [disabled]="
                      approvingAccreditationId === accreditation._id ||
                      rejectingAccreditationId === accreditation._id
                    "
                    (click)="approveAccreditation(accreditation._id)"
                  >
                    {{
                      approvingAccreditationId === accreditation._id
                        ? 'Aprobando...'
                        : 'Aprobar acreditación'
                    }}
                  </button>
              
                </div>
              }

            </article>

          } @empty {

            <div class="empty-state">

              <strong>
                Este estudiante aún no tiene acreditaciones
              </strong>

              <span>
                Cuando registres una acreditación aparecerá aquí.
              </span>

            </div>

          }

        </div>

      </section>
      }

        <!-- =========================================
             ACTIVIDADES
        ========================================== -->

        @if (accActiveTab === 'actividades') {
        <section class="detail-card">
  
          <div class="section-title">
  
            <div>
  
              <span class="section-kicker">
                Participación
              </span>
  
              <h2>
                Actividades del estudiante
              </h2>
  
              <p>
                Revisa su estado de participación y horas validadas.
              </p>
  
            </div>
  
  
            <div class="activity-count">
  
              <strong>
                {{ student.assignedActivities.length }}
              </strong>
  
              <span>
                actividades
              </span>
  
            </div>
  
          </div>
  
  
          <div class="activities-list">
  
            @for (
              activity of student.assignedActivities;
              track activity.activityRef
            ) {
  
              <article class="activity-row">
  
                <div
                  class="activity-icon"
                  [class.icon-validated]="activity.status === 'validated'"
                  [class.icon-absent]="activity.status === 'absent'"
                  [class.icon-attended]="activity.status === 'attended'"
                >
  
                  @switch (activity.status) {
  
                    @case ('validated') {
                      ✓
                    }
  
                    @case ('absent') {
                      ✕
                    }
  
                    @case ('attended') {
                      ✓
                    }
  
                    @default {
                      !
                    }
  
                  }
  
                </div>
  
  
                <div class="activity-main">
  
                  <span class="activity-type">
                    {{ activity.type }}
                  </span>
  
                  <h3>
                    {{ activity.title }}
                  </h3>

                  @if (activity.interactionFolio) {
                    <div class="activity-folio-row">
                      <app-folio-pill
                        [folio]="activity.interactionFolio"
                        [interactionType]="activity.interactionType || 'OP'"
                        [showHours]="true"
                        [hours]="activity.validatedHours || 0"
                      ></app-folio-pill>
                    </div>
                  }
  
  
                  <div
                    class="activity-status"
                    [class.status-registered]="activity.status === 'registered'"
                    [class.status-attended]="activity.status === 'attended'"
                    [class.status-absent]="activity.status === 'absent'"
                    [class.status-validated]="activity.status === 'validated'"
                  >
  
                    @switch (activity.status) {
  
                      @case ('registered') {
                        Registrado
                      }
  
                      @case ('attended') {
                        Asistió
                      }
  
                      @case ('absent') {
                        No asistió
                      }
  
                      @case ('validated') {
                        Horas validadas
                      }
  
                      @default {
                        Registrado
                      }
  
                    }
  
                  </div>
  
                </div>
  
  
                <div class="activity-meta">
  
                  <div>
                    <span>
                      Valor
                    </span>
                    <strong>
                      {{ activity.valueInHours }} h
                    </strong>
                  </div>
                  
                  <div>
                    <span>
                      Validadas
                    </span>
                    <strong>
                      {{ activity.validatedHours }} h
                    </strong>
                  </div>
                  
                  <div>
                    <span>
                      Fecha límite
                    </span>
                    <strong>
                      {{ activity.dueDate | date:'mediumDate' }}
                    </strong>
                  </div>
                  
                  <div>
                    <span>
                      Desempeño
                    </span>
                  
                    <strong>
                      @switch (activity.status === 'absent' ? 'absent' : activity.performance) {
                        @case ('very_bad') {
                          Muy malo
                        }
                        @case ('bad') {
                          Malo
                        }
                        @case ('good') {
                          Bueno
                        }
                        @case ('very_good') {
                          Muy bueno
                        }
                        @case ('excellent') {
                          Excelente
                        }
                        @case ('absent') {
                          Inasistencia
                        }
                        @default {
                          Pendiente de evaluación
                        }
                      }
                    </strong>
                  </div>
                  
                  <div>
                    <span>
                      Comentarios
                    </span>
                  
                    <strong
                      [class.comment-expanded]="
                        expandedCommentId === activity.activityRef
                      "
                    >
                      @if (activity.performanceComment?.trim()) {
                        {{ activity.performanceComment }}
                      } @else {
                        Sin comentarios
                      }
                    </strong>
                  
                    @if (activity.performanceComment?.trim()) {
                      <button
                        type="button"
                        class="comment-toggle"
                        (click)="toggleComment(activity.activityRef)"
                      >
                        {{
                          expandedCommentId === activity.activityRef
                            ? 'Ocultar comentario'
                            : 'Ver comentario'
                        }}
                      </button>
                    }
                  </div>
  
                </div>
  
              </article>
  
            } @empty {
  
              <div class="empty-state">
  
                <strong>
                  Este estudiante aún no tiene actividades
                </strong>
  
                <span>
                  Cuando se registre a una actividad aparecerá aquí.
                </span>
  
              </div>
  
            }
  
          </div>
  
        </section>
        }

        <!-- =========================================
             TODAS (tabla combinada)
        ========================================== -->

        @if (accActiveTab === 'todas') {
        <section class="detail-card">

          <div class="section-title">
            <div>
              <span class="section-kicker">
                Resumen
              </span>
              <h2>
                Acreditaciones y actividades
              </h2>
              <p>
                Vista combinada de todas las acreditaciones y actividades del estudiante.
              </p>
            </div>
            <div class="activity-count">
              <strong>
                {{ accreditations.length + student.assignedActivities.length }}
              </strong>
              <span>
                registros
              </span>
            </div>
          </div>

          @if (accreditations.length + student.assignedActivities.length > 0) {
            <div class="sd-combined-table-wrapper">
              <table class="sd-combined-table">
                <thead>
                  <tr>
                    <th>Folio</th>
                    <th>Origen</th>
                    <th>Tipo</th>
                    <th>Estado</th>
                    <th>Horas</th>
                    <th>Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  @for (a of accreditations; track a._id) {
                    <tr>
                      <td data-label="Folio">
                        @if (a.interactionFolio) {
                          <app-folio-pill
                            [folio]="a.interactionFolio"
                            [interactionType]="a.interactionType || 'OP'"
                            [showHours]="false"
                          ></app-folio-pill>
                        } @else {
                          --
                        }
                      </td>
                      <td data-label="Origen">Acreditación</td>
                      <td data-label="Tipo">{{ a.type }}</td>
                      <td data-label="Estado">{{ a.status }}</td>
                      <td data-label="Horas">{{ a.hoursAccredited ?? '--' }}</td>
                      <td data-label="Fecha">{{ a.date | date }}</td>
                    </tr>
                  }
                  @for (ac of student.assignedActivities; track ac.activityRef) {
                    <tr>
                      <td data-label="Folio">
                        @if (ac.interactionFolio) {
                          <app-folio-pill
                            [folio]="ac.interactionFolio"
                            [interactionType]="ac.interactionType || 'OP'"
                            [showHours]="false"
                          ></app-folio-pill>
                        } @else {
                          --
                        }
                      </td>
                      <td data-label="Origen">Actividad</td>
                      <td data-label="Tipo">{{ ac.type || ac.title }}</td>
                      <td data-label="Estado">{{ ac.status }}</td>
                      <td data-label="Horas">{{ ac.validatedHours ?? ac.valueInHours ?? '--' }}</td>
                      <td data-label="Fecha">{{ (ac.assignedAt || ac.dueDate) ? ((ac.assignedAt || ac.dueDate) | date) : '--' }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          } @else {
            <div class="empty-state">
              <strong>
                Este estudiante aún no tiene acreditaciones ni actividades.
              </strong>
            </div>
          }

        </section>
        }
  
      } @else {
  
        <div class="detail-error">
          No se pudo cargar el estudiante.
        </div>
  
      }
  
    }

    @if (showAccreditationModal) {
      <div
        class="confirmation-overlay"
        (click)="closeAccreditationModal()"
      >
        <div
          class="accreditation-modal"
          (click)="$event.stopPropagation()"
        >
          <div class="accreditation-modal-header">
            <div>
              <span class="section-eyebrow">Servicio social</span>
              <h2>Nueva acreditación</h2>
              <p>
                Registra una actividad realizada por el voluntario.
              </p>
            </div>
    
            <button
              type="button"
              class="modal-close-button"
              (click)="closeAccreditationModal()"
            >
              ×
            </button>
          </div>
    
          <div class="accreditation-modal-body">
            <div class="accreditation-form-group">
              <label for="accreditationType">
                Tipo de acreditación
              </label>
            
              <app-custom-select
                id="accreditationType"
                [options]="accreditationTypeOptions"
                [(ngModel)]="selectedAccreditationType"
                placeholder="Selecciona una opción"
              ></app-custom-select>
            </div>

            @if (selectedAccreditationType === 'EVENT') {
              <div class="accreditation-form-grid">
            
                <div class="accreditation-form-group">
                  <label for="eventDate">
                    Fecha de la actividad
                  </label>
            
                  <app-custom-datepicker
                    id="eventDate"
                    [(ngModel)]="eventDate"
                    placeholder="Selecciona la fecha"
                  ></app-custom-datepicker>
                </div>
            
                <div class="accreditation-form-group">
                  <label for="eventType">
                    Tipo de evento
                  </label>
            
                  <app-custom-select
                    id="eventType"
                    [options]="eventTypeOptions"
                    [(ngModel)]="eventType"
                    placeholder="Selecciona un tipo"
                  ></app-custom-select>
                </div>
            
                <div class="accreditation-form-group">
                  <label for="hoursPerformed">
                    Horas realizadas
                  </label>
            
                  <input
                    id="hoursPerformed"
                    type="number"
                    min="0"
                    step="0.5"
                    placeholder="Ej. 3"
                    [(ngModel)]="hoursPerformed"
                  />
                </div>
            
              </div>
            }

            @if (selectedAccreditationType === 'INDUCTION') {
              <div class="accreditation-form-group">
                <label for="inductionDate">
                  Fecha de la inducción
                </label>
            
                <app-custom-datepicker
                  id="inductionDate"
                  [(ngModel)]="eventDate"
                  placeholder="Selecciona la fecha"
                ></app-custom-datepicker>
              </div>
            }

            @if (selectedAccreditationType === 'IDENTIFICATION') {
              <div class="accreditation-form-grid">
                <div class="accreditation-form-group">
                  <label for="identificationDate">
                    Fecha de la actividad
                  </label>
            
                  <app-custom-datepicker
                    id="identificationDate"
                    [(ngModel)]="eventDate"
                    placeholder="Selecciona la fecha"
                  ></app-custom-datepicker>
                </div>
            
                <div class="accreditation-form-group">
                  <label for="identificationQuantity">
                    Personas identificadas
                  </label>
            
                  <input
                    id="identificationQuantity"
                    type="number"
                    min="1"
                    step="1"
                    placeholder="Ej. 3"
                    [(ngModel)]="identificationQuantity"
                  />
                </div>
              </div>
            }

            @if (selectedAccreditationType === 'STERILIZATION') {
              <div class="accreditation-form-grid">
                <div class="accreditation-form-group">
                  <label for="sterilizationDate">
                    Fecha de la actividad
                  </label>
            
                  <app-custom-datepicker
                    id="sterilizationDate"
                    [(ngModel)]="eventDate"
                    placeholder="Selecciona la fecha"
                  ></app-custom-datepicker>
                </div>
            
                <div class="accreditation-form-group">
                  <label for="sterilizationQuantity">
                    Animales vinculados
                  </label>
            
                  <input
                    id="sterilizationQuantity"
                    type="number"
                    min="1"
                    step="1"
                    placeholder="Ej. 3"
                    [(ngModel)]="sterilizationQuantity"
                  />
                </div>
              </div>
            }

            @if (selectedAccreditationType === 'ADOPTION') {
              <div class="accreditation-form-grid">
                <div class="accreditation-form-group">
                  <label for="adoptionDate">
                    Fecha de la adopción
                  </label>
            
                  <app-custom-datepicker
                    id="adoptionDate"
                    [(ngModel)]="eventDate"
                    placeholder="Selecciona la fecha"
                  ></app-custom-datepicker>
                </div>
            
                <div class="accreditation-form-group">
                  <label for="adoptionQuantity">
                    Adopciones vinculadas
                  </label>
            
                  <input
                    id="adoptionQuantity"
                    type="number"
                    min="1"
                    step="1"
                    placeholder="Ej. 1"
                    [(ngModel)]="adoptionQuantity"
                  />
                </div>
              </div>
            
              <div class="accreditation-info-box">
                <strong>Periodo de prueba de 15 días</strong>
                <p>
                  Las horas de esta acreditación se asignarán
                  después de que termine el periodo de prueba y
                  la acreditación sea aprobada.
                </p>
              </div>
            }

            @if (selectedAccreditationType === 'ADOPTION_MODULE') {
              <div class="accreditation-form-grid">
                <div class="accreditation-form-group">
                  <label for="adoptionModuleDate">
                    Fecha de la actividad
                  </label>
            
                  <app-custom-datepicker
                    id="adoptionModuleDate"
                    [(ngModel)]="eventDate"
                    placeholder="Selecciona la fecha"
                  ></app-custom-datepicker>
                </div>
            
                <div class="accreditation-form-group">
                  <label for="adoptionModuleQuantity">
                    Módulos de adopción coordinados
                  </label>
            
                  <input
                    id="adoptionModuleQuantity"
                    type="number"
                    min="1"
                    step="1"
                    placeholder="Ej. 1"
                    [(ngModel)]="adoptionModuleQuantity"
                  />
                </div>
              </div>
            }

            @if (selectedAccreditationType === 'TALK') {
              <div class="accreditation-form-grid">
                <div class="accreditation-form-group">
                  <label for="talkDate">
                    Fecha de la plática
                  </label>
            
                  <app-custom-datepicker
                    id="talkDate"
                    [(ngModel)]="eventDate"
                    placeholder="Selecciona la fecha"
                  ></app-custom-datepicker>
                </div>
            
                <div class="accreditation-form-group">
                  <label for="talkParticipantsCount">
                    Número de participantes
                  </label>
            
                  <input
                    id="talkParticipantsCount"
                    type="number"
                    min="1"
                    step="1"
                    placeholder="Ej. 50"
                    [(ngModel)]="talkParticipantsCount"
                  />
                </div>
              </div>
            
              <div class="accreditation-info-box">
                <strong>Requisito mínimo: 50 participantes</strong>
                <p>
                  La plática genera 50 horas de acreditación cuando
                  cuenta con al menos 50 participantes.
                </p>
              </div>
            }

            @if (selectedAccreditationType === 'CAMPAIGN') {
              <div class="accreditation-form-grid">
                <div class="accreditation-form-group">
                  <label for="campaignDate">
                    Fecha de la campaña
                  </label>
            
                  <app-custom-datepicker
                    id="campaignDate"
                    [(ngModel)]="eventDate"
                    placeholder="Selecciona la fecha"
                  ></app-custom-datepicker>
                </div>
            
                <div class="accreditation-form-group">
                  <label for="campaignAnimalsEnrolled">
                    Animales inscritos
                  </label>
            
                  <input
                    id="campaignAnimalsEnrolled"
                    type="number"
                    min="1"
                    step="1"
                    placeholder="Ej. 60"
                    [(ngModel)]="campaignAnimalsEnrolled"
                  />
                </div>

                <div class="accreditation-form-group">
                  <label for="campaignInfrastructureAvailable">
                    Infraestructura disponible
                  </label>
                
                  <app-custom-select
                    id="campaignInfrastructureAvailable"
                    [options]="campaignInfrastructureOptions"
                    [(ngModel)]="campaignInfrastructureAvailable"
                  ></app-custom-select>
                </div>
              </div>
            
              <div class="accreditation-info-box">
                <strong>Requisito para acreditar 100 horas</strong>
                <p>
                  La campaña debe contar con al menos 60 animales inscritos
                  y disponer de infraestructura para realizarla.
                </p>
              </div>
            }

            @if (selectedAccreditationType === 'MEDIA') {
              <div class="accreditation-form-group">
                <label for="mediaDate">
                  Fecha de la difusión
                </label>
            
                <app-custom-datepicker
                  id="mediaDate"
                  [(ngModel)]="mediaDate"
                  placeholder="Selecciona la fecha"
                ></app-custom-datepicker>
              </div>
            
              <div class="accreditation-info-box">
                <strong>30 horas de acreditación</strong>
                <p>
                  La difusión o publicación gratuita del proyecto ABAQ
                  en medios genera 30 horas de acreditación.
                </p>
              </div>
            }

            @if (selectedAccreditationType === 'SOCIAL_MEDIA') {
              <div class="accreditation-form-grid">
                <div class="accreditation-form-group">
                  <label for="socialMediaDate">
                    Fecha de la publicación
                  </label>
            
                  <app-custom-datepicker
                    id="socialMediaDate"
                    [(ngModel)]="eventDate"
                    placeholder="Selecciona la fecha"
                  ></app-custom-datepicker>
                </div>
            
                <div class="accreditation-form-group">
                  <label for="socialMediaReactionsCount">
                    Número de reacciones
                  </label>
            
                  <input
                    id="socialMediaReactionsCount"
                    type="number"
                    min="0"
                    step="1"
                    placeholder="Ej. 25"
                    [(ngModel)]="socialMediaReactionsCount"
                  />
                </div>
              </div>
            
              <div class="accreditation-info-box">
                <strong>5 horas base + 1 hora por cada 5 reacciones</strong>
                <p>
                  La publicación debe estar aprobada por ABAQ, etiquetar a ABAQ
                  y aparecer en las redes de ABAQ para generar acreditación.
                </p>
              </div>
            }

            @if (selectedAccreditationType === 'DONATION') {
              <div class="accreditation-form-grid">
                <div class="accreditation-form-group">
                  <label for="donationDate">
                    Fecha de la recaudación
                  </label>
            
                  <app-custom-datepicker
                    id="donationDate"
                    [(ngModel)]="eventDate"
                    placeholder="Selecciona la fecha"
                  ></app-custom-datepicker>
                </div>
            
                <div class="accreditation-form-group">
                  <label for="donationAmount">
                    Monto recaudado (MXN)
                  </label>
            
                  <input
                    id="donationAmount"
                    type="number"
                    min="0"
                    step="50"
                    placeholder="Ej. 250"
                    [(ngModel)]="donationAmount"
                  />
                </div>
              </div>
            
              <div class="accreditation-info-box">
                <strong>1 hora por cada $50 recaudados</strong>
                <p>
                  La recaudación debe haber sido previamente acordada
                  y contar con la evidencia correspondiente.
                </p>
              </div>
            }

            @if (selectedAccreditationType === 'ADMINISTRATIVE') {
              <div class="accreditation-form-grid">
                <div class="accreditation-form-group">
                  <label for="administrativeDate">
                    Fecha de la actividad
                  </label>
            
                  <app-custom-datepicker
                    id="administrativeDate"
                    [(ngModel)]="eventDate"
                    placeholder="Selecciona la fecha"
                  ></app-custom-datepicker>
                </div>
            
                <div class="accreditation-form-group">
                  <label for="administrativeHoursAccredited">
                    Horas a acreditar
                  </label>
            
                  <input
                    id="administrativeHoursAccredited"
                    type="number"
                    min="0"
                    step="0.5"
                    placeholder="Ej. 3"
                    [(ngModel)]="administrativeHoursAccredited"
                  />
                </div>
              </div>
            
              <div class="accreditation-info-box">
                <strong>Horas determinadas por ABAQ</strong>
                <p>
                  Las horas de las actividades administrativas se determinan
                  de acuerdo con la actividad realizada.
                </p>
              </div>
            }

            <div class="accreditation-form-group">

              <label for="evidenceUrl">
                Evidencia
              </label>
            
              <input
                id="evidenceUrl"
                type="url"
                placeholder="Pega aquí el enlace de la evidencia"
                [(ngModel)]="evidenceUrl"
              />
            
              <small>
                Puedes agregar un enlace de Google Drive, OneDrive u otro repositorio.
              </small>
            
            </div>
          </div>
    
          <div class="accreditation-modal-footer">
            <button
              type="button"
              class="action-button secondary-action-button"
              (click)="closeAccreditationModal()"
            >
              Cancelar
            </button>
          
            <button
                type="button"
                class="action-button primary-action-button"
                (click)="createAccreditation()"
              >
                Registrar acreditación
              </button>
          </div>
        </div>
      </div>
    }
  
</div>
  
  
  <!-- =========================================
       MODAL: REGISTRAR / EDITAR ENLACE EN LA NUBE
  ========================================== -->
  @if (showDocumentLinkModal) {
    <div class="confirmation-overlay" (click)="closeLinkModal()">
      <div class="cloud-doc-modal" (click)="$event.stopPropagation()">
        
        <div class="modal-header">
          <div>
            <span class="section-eyebrow">Expediente digital</span>
            <h2>Registrar enlace en la nube</h2>
            <p>{{ editingDocumentTitle }}</p>
          </div>
          <button type="button" class="modal-close-button" (click)="closeLinkModal()">✕</button>
        </div>

        <div class="modal-body">
          <!-- TIP DE INCÓGNITO EN EL MODAL -->
          <div class="modal-incognito-tip">
            <span class="material-symbols-outlined tip-symbol">lightbulb</span>
            <div>
              <strong>Tip de verificación en incógnito:</strong>
              <p>
                Prueba tu enlace en una <strong>ventana de incógnito</strong> para verificar que cualquiera en ABAQ pueda abrirlo y consultarlo sin solicitar permisos ni acceso.
              </p>
            </div>
          </div>

          <p class="modal-instruction">
            {{ editingDocumentSubtitle }} Pega la liga pública o compartida de Google Drive, OneDrive o tu nube institucional:
          </p>

          <div class="modal-input-group">
            <label for="cloudDocUrlInput">Enlace compartido (URL) <span class="text-required">*</span></label>
            <div class="input-with-test-action">
              <input
                id="cloudDocUrlInput"
                type="url"
                class="modal-input-field"
                [(ngModel)]="editingDocumentUrl"
                placeholder="https://drive.google.com/file/d/... o https://1drv.ms/..."
                (ngModelChange)="documentLinkError = null"
                (keydown.enter)="saveDocumentLink()"
                autofocus
              />
              <button
                type="button"
                class="btn-test-action"
                (click)="testLink(editingDocumentUrl)"
                [disabled]="!editingDocumentUrl.trim()"
                title="Probar si el enlace abre en una nueva pestaña"
              >
                <span class="material-symbols-outlined">open_in_new</span> Probar enlace
              </button>
            </div>
            @if (documentLinkError) {
              <span class="field-error-text">⚠️ {{ documentLinkError }}</span>
            }
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="modal-btn-cancel"
            (click)="closeLinkModal()"
            [disabled]="isSavingDocumentLink"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="modal-btn-save"
            (click)="saveDocumentLink()"
            [disabled]="isSavingDocumentLink"
          >
            @if (isSavingDocumentLink) {
              Guardando enlace...
            } @else {
              Guardar enlace
            }
          </button>
        </div>

      </div>
    </div>
  }

  <app-inactivate-volunteer-modal
    *ngIf="showInactivateModal && student"
    [targetId]="student.id"
    [targetName]="student.fullName || ''"
    [targetFolio]="student.folio || ''"
    targetRole="student"
    (confirmed)="handleInactivateConfirmed($event)"
    (cancelled)="closeInactivateModal()"
  >
  </app-inactivate-volunteer-modal>
